import { type ReactNode } from "react";
import { toZonedTime } from "date-fns-tz";
import { useField } from "formik";

import { ThemedDateField } from "@vega-core/components/Form/Controls/DateField/ThemedDateField";
import { useTouchFieldOnSubmit } from "@vega-core/helpers/formik.helper";
import { isTruthy } from "@vega-core/utils/isTruthy";

type Props = {
  isOptional?: boolean;
  label?: string;
  labelTag?: ReactNode;
  isBirthday?: boolean;
  fullWidth?: boolean;
  name: string;
  disabled?: boolean;
  constrainInputWidth?: boolean;
  onlyFuture?: boolean;
  disableFuture?: boolean;
  maskValue?: boolean;
};

export function DateField({
  isOptional,
  label,
  labelTag,
  name,
  isBirthday,
  fullWidth = true,
  disabled,
  constrainInputWidth = false,
  onlyFuture,
  disableFuture,
  maskValue,
}: Props) {
  const [field, meta, helpers] = useField(name);
  useTouchFieldOnSubmit(name);

  return (
    <ThemedDateField
      constrainInputWidth={constrainInputWidth}
      disableFuture={disableFuture}
      disabled={disabled}
      error={meta.touched && isTruthy(meta.error) ? meta.error : undefined}
      fullWidth={fullWidth}
      isBirthday={isBirthday}
      isOptional={isOptional}
      isSubscriptionQuestion
      label={label}
      labelTag={labelTag}
      maskValue={maskValue}
      name={field.name}
      onBlur={() => helpers.setTouched(true)}
      onChange={(val) => helpers.setValue(val?.toISOString())}
      onClear={() => helpers.setValue(undefined)}
      onlyFuture={onlyFuture}
      value={
        field.value && typeof field.value === "string"
          ? toZonedTime(
              field.value.slice(0, 10),
              Intl.DateTimeFormat().resolvedOptions().timeZone,
            )
          : undefined
      }
      withBorder
    />
  );
}
